import {useClient} from '@adamlip/okeoke.client';
import {NumericFormat} from 'react-number-format';

function SubmittedOrderItem(props) {
  const {item, details} = props;

  const {getName} = useClient();

  if (item == null) return null;

  return (
    <div className='submitted-orderItem-root'>
      <div className='submitted-orderItem-header'>
        <div className='submitted-orderItem-name'>
          <div className='submitted-orderItem-size'>{`${item.count}`}</div>
          <div className='submitted-orderItem-itemName'>{getName(item.name)}</div>
        </div>
        <div className='submitted-orderItem-price'>
          <NumericFormat value={+item.discountPrice} decimalSeparator=',' suffix=' Ft' thousandSeparator='.' displayType='text' />
        </div>
      </div>
      {details != null && (
        <div className='submitted-orderItem-details font-smallest'>
          <div className='submitted-orderItem-notes'>{item.notes}</div>
          <div className='submitted-orderItem-modifierGroups'>
            {item.modifiers
              .filter((modifier) => modifier.count > 0)
              .map((modifier) => (
                <div key={modifier.uuid} className='modifier-root'>
                  <div className='modifier-count'>{modifier.count}</div>
                  <div className='modifier-name'>{getName(modifier.name)}</div>
                  <div className='modifier-price'>{parseInt(modifier.price) > 0 ? `+${parseInt(modifier.price)} Ft` : ''}</div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SubmittedOrderItem;
